export default __webpack_public_path__ + "static/media/ic_kmx_40.9e968208.svg";